'use strict'

module.exports = () => ({
  isValidContext: () => false
})
